define('OutSystems/ReactView/AnimatedGroup',["require", "exports", "tslib", "@outsystems/virtualized-list"], function (require, exports, tslib_1, virtualized_list_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.AnimatedGroup = void 0;
    var AnimatedGroup = (function (_super) {
        tslib_1.__extends(AnimatedGroup, _super);
        function AnimatedGroup() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        AnimatedGroup.prototype.getDefaultTransitionName = function () {
            return "os-animated";
        };
        return AnimatedGroup;
    }(virtualized_list_1.AnimatedSizeGroup));
    exports.AnimatedGroup = AnimatedGroup;
});
//# sourceMappingURL=AnimatedGroup.js.map;
